import React, { useEffect, useState } from 'react'
import { useBlogsHook } from '../useBlogsHook'
import BlogListComponent from './BlogListComponent';
import InfiniteScrollSentinel from './InfiniteScrollSentinel';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import DeleteBlogComponentV2 from './DeleteBlogComponent';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    height: 'auto',
    minHeight: 300,
    bgcolor: 'white',
    border: '1px solid #000',
    p: 4,
    borderRadius: '10px',
    justifyContent: 'center',
    alignItems: 'center',
};



export default function DeleteBlog() {
    const [open, setOpen] = useState(false);
    const [selectedBlogTitle, setSelectedBlogTitle] = useState('');
    const [selectedBlogId, setSelectedBlogId] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const {
        fetchAllBlogs,
        fetchMoreBlogs,
        searchBlogs,
        blogs,
        blogsLoading,
        deleteBlog,
        loadingMore,
        hasMoreBlogs,
    } = useBlogsHook();

    useEffect(() => {
        fetchAllBlogs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (searchQuery.trim() === '') {
            fetchAllBlogs();
        } else if (searchQuery.trim().length >= 3) {
            const delaySearch = setTimeout(() => {
                searchBlogs(searchQuery);
            }, 500); // 500ms debounce

            return () => clearTimeout(delaySearch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);
    if (blogsLoading === true || blogs === null) {
        return <div>Loading...</div>
    };
    const handleClose = () => setOpen(false);
    return (
        <div className='flex justify-center items-center flex-col'>
            <h1 className='text-2xl font-bold my-8'>
                Delete Blog
            </h1>
            
            {/* Search Input */}
            <div className='w-full max-w-2xl my-4 px-4'>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search blogs... (min. 3 characters)"
                    className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                />
                {searchQuery.trim().length > 0 && searchQuery.trim().length < 3 && (
                    <p className='text-sm text-gray-500 mt-1'>Please enter at least 3 characters to search</p>
                )}
            </div>

            {
                blogs.map((blog: any) => {
                    return (
                        <DeleteBlogComponentV2
                            key={blog._id}
                            id={blog._id}
                            title={blog.blogTitle1}
                            image={blog.blogImage1}
                            onClick={() => {
                                setSelectedBlogTitle(blog.blogTitle1);
                                setSelectedBlogId(blog._id);
                                setOpen(true);
                            }}
                            isDeleted={blog.isDeleted}
                        />
                    )
                })
            }
            {searchQuery.trim() === '' && hasMoreBlogs && (
                <>
                    <InfiniteScrollSentinel
                        onLoadMore={fetchMoreBlogs}
                        disabled={loadingMore}
                    />
                    {loadingMore && <p className="py-4 text-gray-500">Daha fazla yükleniyor...</p>}
                </>
            )}
            {
                <Modal
                    BackdropProps={{
                        style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } // Şeffaf arka plan
                    }}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    open={open}
                    onClose={handleClose}>
                    <Box sx={style}>
                        <Typography variant="h6" component="h2">
                            Are You Sure?
                        </Typography>
                        <Typography sx={{ mt: 2 }}>
                            You are going to delete this blog. <a className='font-bold text-black'>{selectedBlogTitle}</a>
                        </Typography>
                        <div
                            className='flex justify-evenly items-center mt-24 w-full'
                        >
                            <Button
                                onClick={async () => {
                                    await deleteBlog(selectedBlogId);
                                    handleClose();
                                }}
                                color='error'
                                variant='contained'
                                className='mt-4 ml-4 w-32'>
                                Delete
                            </Button>
                            <Button
                                onClick={handleClose}
                                variant='outlined'
                                className='mt-4 w-32'>
                                Cancel
                            </Button>
                        </div>
                    </Box>
                </Modal >
            }
        </div>
    )
}
